import { render, staticRenderFns } from "./PCMSReport.vue?vue&type=template&id=53b31312"
import script from "./PCMSReport.vue?vue&type=script&lang=js"
export * from "./PCMSReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports